var dropdownToggles = document.querySelectorAll('.dropdown__toggle');
for (var i = 0, len = dropdownToggles.length; i < len; i++) {
  var dropdownToggle = dropdownToggles[i];
  dropdownToggle.addEventListener('click', function(e) {
    this.parentNode.classList.toggle('dropdown--active');
    e.preventDefault();
  });
}

window.addEventListener('click', function(e) {
  var dropdowns = document.querySelectorAll('.dropdown--active');
  for (var i = 0, len = dropdowns.length; i < len; i++) {
    var dropdown = dropdowns[i];
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('dropdown--active');
    }
  }
});
